import React from 'react';
import styled from 'styled-components';
import BreakdownGroupMenu from './BreakdownGroupMenu';
import BreakdownBinning from './BreakdownBinning';
import { QueryType } from '../../../../../utils/apollo/graphqlSchema';
import useQueryTypeFromLocation from '../../../../../utils/routes/useQueryTypeFromLocation';
import { useActionsVisibilityContext } from '../../../../ActionsVisibilityContext';
import { IBuilderBreakdownGroup } from '../../../../../redux/slices/oldBuilder/breakdown/types';
import { BuilderRowActions } from '../../../BuilderActions';
import {
  BreakdownGroupFilterTrigger,
  BreakdownGroupFilterView,
} from './BreakdownGroupFilter';
import { useHighlightingContext } from '../../../../HighlightingContext';
import ThinDivider from '../../../../ThinDivider';
import { SquareRemoveButton } from '../../../../Button';

interface IProps {
  group: IBuilderBreakdownGroup;
  groupIndex: number;
  onRemove: (groupIndex: number) => () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

const BreakdownGroup = ({ group, groupIndex, onRemove }: IProps) => {
  const { activateHighlighting, deactivateHighlighting } =
    useHighlightingContext();

  const { actionsVisible } = useActionsVisibilityContext();

  const queryType = useQueryTypeFromLocation();
  const isDataTable = queryType === QueryType.DataTable;

  const { field, filter, binning } = group;

  const shouldDisplayBinningOption =
    field?.bucketKinds && field?.bucketKinds?.length > 0 && !isDataTable;

  return (
    <>
      <Container>
        <BreakdownGroupMenu groupIndex={groupIndex} />
        {field?.key && (
          <>
            <BreakdownGroupFilterTrigger groupIndex={groupIndex} />
            {shouldDisplayBinningOption && (
              <ThinDivider layout="vertical" size="short" />
            )}
          </>
        )}
        {shouldDisplayBinningOption && (
          <BreakdownBinning
            // temporary: key was introduced to force binning to re-render
            key={`${field?.key}-${groupIndex}`}
            groupIndex={groupIndex}
            field={field}
            binning={binning}
          />
        )}
        <BuilderRowActions>
          {actionsVisible && (
            <SquareRemoveButton
              onClick={onRemove(groupIndex)}
              onMouseEnter={activateHighlighting}
              onMouseLeave={deactivateHighlighting}
              content={'Remove Breakdown'}
            />
          )}
        </BuilderRowActions>
      </Container>
      {field && filter && (
        <BreakdownGroupFilterView
          field={field}
          predicate={filter}
          groupIndex={groupIndex}
        />
      )}
    </>
  );
};

export default BreakdownGroup;
